import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DadosBancariosADO } from '../models/dadosBancariosADO.model';

export class DadosBancariosADOService extends ApiService implements BaseService<DadosBancariosADO>{

    private strAction = 'api/DadosBancariosADO';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<DadosBancariosADO[]> {
        return this.get<DadosBancariosADO[]>(this.strAction + `/GetAll`);
    }

    deleteById(idPessoa: number) {
        return this.post(this.strAction + `/DeleteById?id=${idPessoa}`);
    }

    getById(idPessoa: number): Observable<DadosBancariosADO> {
        return this.get(this.strAction + `/GetById?id=${idPessoa}`);
    }

    Post(dadosBancariosADO: DadosBancariosADO): Observable<DadosBancariosADO> {
        return this.post<DadosBancariosADO>(this.strAction + `/PostInsereDadosBancarios`, dadosBancariosADO);
    }

}